import { useEffect, useRef } from 'react';

/**
 * @template T
 * @param {T} value
 * @returns {T | undefined}
 */
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export default usePrevious;
